const alarmRule = {
  bindings: {
    isActive: '<',
  },
  templateUrl: '/modules/analysis/alarm-rule/alarm-rule.html',
  controller: 'AlarmRuleController',
};

angular
  .module('analysis.module')
  .component('alarmRule', alarmRule);
